package learning.components


import antd.button.button
import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.message.message
import com.jingfangpai.common.orm.mapping.enums.ContentType
import com.jingfangpai.content.model.ContentVo
import react.*
import react.dom.div
import external.ckEditor.CKEditor
import external.ckEditor.ClassicEditor
import external.ckEditor.EditorConf
import external.ckEditor.EditorToolbarConf
import kotlinext.js.Object
import kotlinext.js.js
import kotlinext.js.jsObject
import kotlinx.browser.document
import react.dom.attrs
import react.dom.textarea
import react.router.dom.useHistory
import learning.containers.MeridianEditPageContext

external interface MeridianEditProps : RProps {
    var id:String
}

data class MeridianEditContextData(var placeHolderFunction: (param: String) -> Unit)

val MeridianEdit = functionalComponent<MeridianEditProps> { props ->

    val ctx = useContext(MeridianEditPageContext)
    val history = useHistory()
    val (meridian,setMeridian) = useState(ContentVo().apply {
        type = ContentType.Meridian
    })
    val (editor,setEditor) = useState<CKEditor?>(null)
    val (editorContentLoaded,setEditorContentLoaded) = useState(false)

    fun onContentChanged(event:dynamic,data:dynamic,editorInstance:CKEditor){
        setEditor(editorInstance)
    }

    fun onEditorInit(editor:CKEditor){
        console.log("onEditorInit",editor)
        setEditor(editor)

        editor.editing.view.change( {writer->
            writer.setStyle( "min-height", "400px", editor.editing.view.document.getRoot() );
        } );
        editor.model.document.on("change:data", {event,data->
            onContentChanged(event,data,editor)
        });
    }

    fun onSave(event: dynamic) {
        editor?.let {
            editor.getData().let{ data ->
                meridian.content = data
            }
        }
        if(meridian.title.isNullOrBlank()){
            message.error("请填写经络名称")
            return;
        }
        if(meridian.content.isNullOrBlank()){
            message.error("请详述经络内容")
            return;
        }
        message.loading("正在保存")
        ctx.saveContent(meridian,{ resp->
            if(resp.ok()){
                if(meridian.id.isNullOrBlank()){ //新增
                    history.push(LearningRoute.MeridianEdit.link.url.replace(":id",resp.data?.id?:""))
                }else {
                    resp.data?.let { setMeridian(it) }
                }
            }
        },{
            console.log(it)
            message.error("保存失败，${it.message}")
        })
    }

    useEffect(editor, meridian.content) {
        console.log("Editor initialized, data:", editor?.getData())
        console.log("Meridian content:", meridian.content)
        // Load content when both editor is ready and content is available
        if(editor != null && !editorContentLoaded && meridian.content != null && !meridian.content.isNullOrBlank()){
            console.log("Loading content into editor")
            editor.setData(meridian.content!!)
            setEditorContentLoaded(true)
        }
    }

    useEffect(props.id) {
        if("new"!=props.id){
            if(props.id.length == 32) {
                ctx.getContent(ContentType.Meridian,props.id,{ resp->
                    if(resp.ok() && resp.data !=null){
                        setMeridian(resp.data!!)
                    }else{
                        message.error("获取经络失败")
                    }
                },{
                    message.error("获取经络失败")
                })
            }
        }else{

        }
    }
    useEffectOnce {
        ClassicEditor.create(document.querySelector("#editor"), jsObject<EditorConf> {
            toolbar = jsObject <EditorToolbarConf> {
                alignment = js{
                    options = arrayOf("left","right")
                }
                items = arrayOf(
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "underline",
                    "fontSize",
                    "fontColor",
                    "alignment",
                    "strikethrough",
                    "link",
                    "bulletedList",
                    "numberedList",
                    "|",
                    "outdent",
                    "indent",
                    "|",
                    "imageUpload",
                    "blockQuote",
                    "insertTable",
                    "undo",
                    "redo",
                    "horizontalLine",
                    "removeFormat"
                )
            }
            props.id?.let{ id->
                simpleUpload = js {
                    // The URL that the images are uploaded to.
                    uploadUrl = "/api/file/upload/ckeditor?entityType=Content&entityId=${id}"

                    // Enable the XMLHttpRequest.withCredentials property.
                    withCredentials = false

                    // Headers sent along with the XMLHttpRequest to the upload server.
                    /*headers = js {
                        entityType = "Content"
                        entityId = props.id
                    }*/
                }
            }

            language = "zh-cn"
            licenseKey = ""
         }
        )
            .then(::onEditorInit)
            .catch { error ->
                console.error(error);
            }

    }

    div("MeridianEdit") {
        form {
            attrs{
                layout = "horizontal"
            }
            formItem {
                attrs{
                    label = "经络"
                }
                input {
                    attrs {
                        value = meridian.title ?:""
                        placeholder = "必填"
                        onChange = {event: dynamic ->
                            val _Meridian = Object.assign(ContentVo(),meridian)
                            _Meridian.title = event.target.value as String
                            setMeridian(_Meridian)
                        }
                    }
                }
            }

            formItem {
                attrs{
                    label = "经络详情"
                }
                div{
                    textarea{
                        attrs{
                            rows = "40"
                        }
                        attrs["id"] = "editor"
                    }
                }
            }
            formItem {
                attrs{
                    label = "排序位置"
                }
                input {
                    attrs {
                        type = "number"
                        value = meridian.weight ?:1
                        placeholder = "请填写排序位置"
                        onChange = {event: dynamic ->
                            val _topic = Object.assign(ContentVo(),meridian)
                            _topic.weight = (event.target.value as String).toInt()
                            setMeridian(_topic)
                        }
                    }
                }
            }
            formItem {
                button {
                    attrs{
                        type = "primary"
                        onClick = ::onSave
                    }
                    +"提交"
                }
            }
        }
    }
}
